/*eslint-disable*/
import AddSubGenerator from '../../soroban/AddSubGenerator';
import { isEmpty } from 'lodash';
const THREE_DIGIT_MAX_FIRST_NUMBER = 980;
const FOUR_DIGIT_MAX_FIRST_NUMBER = 9800;
const FIVE_DIGIT_MAX_FIRST_NUMBER = 88000;

export default {
    computed: {
        initialDigitCapacity() {
            if (this.parameters.difficult === 'Однозначные цифры') {
                return 1;
            } else if (this.parameters.difficult === 'Двузначные цифры') {
                return 2;
            } else if (this.parameters.difficult === 'Трехзначные цифры') {
                return 3;
            } else if (this.parameters.difficult === 'Четырехзначные цифры') {
                return 4;
            } else if (this.parameters.difficult === 'Пятизначные цифры') {
                return 5;
            } else if (this.parameters.difficult === 'Шестизначные цифры') {
                return 6;
            } else if (this.parameters.difficult === 'Семизначные цифры') {
                return 7;
            } else if (this.parameters.difficult === 'Восьмизначные цифры') {
                return 8;
            }
        },
        onlyPositiveAnswers() {
            return this.parameters.positiveAnswers && !this.parameters.negativeAnswers;
        },
        onlyNegativeAnswers() {
            return this.parameters.negativeAnswers && !this.parameters.positiveAnswers;
        }
    },
    methods: {
        createGenerator (digit, sumLimit, jumpOver, amountOfActions) {
            return new AddSubGenerator(0, {
                digitsLimit: digit,
                combining: this.parameters.combining,
                combiningDigitCapacities: this.parameters.combiningDigitCapacities,
                sumLimit,
                jumpOver,
                amountOfActions,
                prevNumbers: this.$store.state.trainer.previousNumbers[this.areaIndex || 'first'],
                mirror: this.parameters.mirror,
                simple: this.parameters.simple,
                brothers: this.parameters.brothers,
                brothersOptions: this.parameters.brothersOptions,
                friends: this.parameters.friends,
                friendsOptions: this.parameters.friendsOptions,
                brothersAndFriends: this.parameters.brothersAndFriends,
                brothersAndFriendsOptions: this.parameters.brothersAndFriendsOptions,
                fractions: this.parameters.fractions,
                fractionalPart: +this.parameters.fractionalPart,
                onlyPositiveAnswers: this.onlyPositiveAnswers,
                onlyNegativeAnswers: this.onlyNegativeAnswers,
                interimAnswers: this.parameters.interimAnswers,
            });
        },
        generateArrayOfNumbers() {
            let prevExample = _.cloneDeep(this.numbers);
            this.numbers = [];
            let digit = this.initialDigitCapacity;
            if (this.parameters.fractions) {
                digit += +this.parameters.fractionalPart;
            }
            if (this.parameters.mirror) {
                digit = 1;
            }
            if (this.parameters.roundNumbers && this.initialDigitCapacity !== 1) {
                digit -= 1;
            }
            let amountOfActions = +this.parameters.amountOfActions;
            let sumLimit = 5 * Math.pow(10, digit);
            this.parameters.stayIn && (sumLimit /= 5);
            let jumpOver = this.parameters.jumpOver ?
                this.parameters.jumpOver.value || this.parameters.jumpOver || false : false;
            let num;
            let correctAnswer;
            let prevCorrectAnswer = this.correctAnswer;
            let counterOfIdenticalAnswers = 0;
            let differenceOfExamples = [];
            let notFixedSimpleNumberIsNotInExample;
            do {
                let generator = this.createGenerator(digit, sumLimit, jumpOver, amountOfActions);
                this.numbers = [];
                correctAnswer = 0;
                let newExample = [];
                for (let i = 0; i < amountOfActions; i++) {
                    num = null;
                    while (!num) {
                        num = generator.nextNum();
                    }
                    if (this.parameters.fractions) {
                        num /= Math.pow(10, +this.parameters.fractionalPart);
                    }
                    if (this.numbers.length === 0 && this.parameters.negativeAnswers) {
                        if (this.initialDigitCapacity === 3 && num > THREE_DIGIT_MAX_FIRST_NUMBER) {
                            prevCorrectAnswer = correctAnswer;
                            break;
                        }
                        if (this.initialDigitCapacity === 4 && num > FOUR_DIGIT_MAX_FIRST_NUMBER) {
                            prevCorrectAnswer = correctAnswer;
                            break;
                        }
                        if (this.initialDigitCapacity === 5 && num > FIVE_DIGIT_MAX_FIRST_NUMBER) {
                            prevCorrectAnswer = correctAnswer;
                            break;
                        }
                    }
                    if (this.parameters.mirror) {
                        let reminder;
                        for (let i = 1; i < this.initialDigitCapacity; i++) {
                            reminder = num % 10;
                            num *= 10;
                            num += reminder;
                        }
                    }
                    if (this.parameters.roundNumbers) {
                        num *= 10;
                    }
                    this.numbers.push(num);
                    newExample.push(num);
                    correctAnswer = +(correctAnswer + num).toFixed(2);
                }

                const onlyTwoSimpleNumbersChosen = this.parameters.simple.length === 2 &&
                    isEmpty(this.parameters.friends) &&
                    isEmpty(this.parameters.brothers) &&
                    isEmpty(this.parameters.brothersAndFriends);

                const FIXED_SIMPLE_NUMBERS = [1, 2];
                const notFixedSimpleNumber = this.parameters.simple.find(number => !FIXED_SIMPLE_NUMBERS.includes(number));

                notFixedSimpleNumberIsNotInExample = onlyTwoSimpleNumbersChosen && notFixedSimpleNumber &&
                    !newExample.map(Math.abs).find(number => number.toString().includes(notFixedSimpleNumber));

                differenceOfExamples = _.difference(newExample, prevExample);
                if (prevCorrectAnswer === correctAnswer) {
                    counterOfIdenticalAnswers++;
                    if (counterOfIdenticalAnswers >= 100) {
                        break;
                    }
                }
                if (prevCorrectAnswer === correctAnswer) {
                    prevExample = _.cloneDeep(newExample);
                }
            } while (prevCorrectAnswer === correctAnswer && differenceOfExamples.length === 0 || notFixedSimpleNumberIsNotInExample);
            this.correctAnswer = correctAnswer;
        },
    }
}
